// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type IsErpZucchettiExportActiveQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type IsErpZucchettiExportActiveQueryResult = { __typename?: 'Query', isErpZucchettiExportActive: boolean };

export const IsErpZucchettiExportActiveGql = gql`
    query IsErpZucchettiExportActive {
  isErpZucchettiExportActive
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsErpZucchettiExportActiveInjectable extends Apollo.Query<IsErpZucchettiExportActiveQueryResult, IsErpZucchettiExportActiveQueryVariables> {
    override document = IsErpZucchettiExportActiveGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */